import { useDefaultWeChatConfig, useDefaultWxWorkConfig } from "@/utils";
import { mapGetters } from "vuex";

export default {
  computed: {
    ...mapGetters(["runInWxWork", "runInWeChat"]),
  },
  created() {
    // 获取默认权限，并隐藏分享目录
    if (this.runInWxWork) {
      useDefaultWxWorkConfig();
    } else if (this.runInWeChat) {
      useDefaultWeChatConfig();
    }
  },
};
